import { cn } from '../../lib/cn';
import { Card } from '../ui';

type Props = {
  capabilities?: string[];
  activeSubscriptions?: number;
  deadEvents?: number;
  health?: 'healthy' | 'warning' | 'error';
};

export function WebhookStatusPanel({
  capabilities = [],
  activeSubscriptions = 4,
  deadEvents = 0,
  health = 'healthy',
}: Props) {
  const healthLabel = { healthy: 'All webhooks healthy', warning: '1 subscription degraded', error: 'Dead letter queue active' };

  return (
    <Card padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Webhook Management</p>
      <p className={cn(
        'mt-1 text-sm font-medium',
        health === 'healthy' ? 'text-success-700 dark:text-success-300' : health === 'warning' ? 'text-warning-700' : 'text-error-700',
      )}>
        {healthLabel[health]}
      </p>
      <dl className="mt-3 grid grid-cols-2 gap-2 text-sm">
        <div>
          <dt className="text-slate-500">Active Subscriptions</dt>
          <dd className="font-semibold">{activeSubscriptions}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Dead Events</dt>
          <dd className="font-semibold">{deadEvents}</dd>
        </div>
      </dl>
      {capabilities.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1">
          {capabilities.map((c) => (
            <span key={c} className="rounded border border-slate-200 px-2 py-0.5 text-xs dark:border-slate-700">{c}</span>
          ))}
        </div>
      )}
    </Card>
  );
}
